import { Official, Player } from "@/models/gameGeneral";

const mapFunctionToAbbreviation = (personFunction: string) => {
  switch (personFunction) {
    case "TRAINER":
      return "T";
    case "TRAINER_ASSISTANT":
      return "CT";
    case "TRAINER_ASSISTANT_SCOUT":
      return "SC";
    case "PHYSIOTHERAPIST":
      return "P";
    case "PHYSICIAN":
      return "A";
    default:
      return "";
  }
};

export const getAddressee = (person: Official | Player): string => {
  if ("jerseyNumber" in person) {
    return `#${person.jerseyNumber}${person.isLibero ? " (L)" : ""}: ${person.lastName}, ${person.firstName}`;
  } else if ("function" in person) {
    return `${mapFunctionToAbbreviation(person.function)}: ${person.lastName}, ${person.firstName}`;
  } else {
    return "";
  }
};
